import React, { Component } from 'react'
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl'
import ProjectDetailsEditForm from './details.component.jsx'
import ProjectCustomerEditForm from "./customerselectform.component.jsx"
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import '../quoteedit.scss'
import LoadingSpinner from "../../common/spinner/loading.component.jsx"

const messages = defineMessages({
    "title_template": {
        id: 'quote.edit.project.title_template',
        defaultMessage: '{customerName} project',
    }
})

class ProjectEdit extends Component {

    constructor(props, context) {
        super(props, context)
        const project = this.props.value || {
            attributes: {},
        }

        this.state = {
            editable: true,
            initialContactId: this.props.initialContactId || '',
            quoteId: this.props.quoteId || '',
            isEditable: this.props.isEditable || false,
            contactId: project.attributes.contactId || this.props.initialContactId || '',
            project: {
                id: project.id || '',
                attributes: {
                    title: project.attributes.title || '',
                    description: project.attributes.description || '',
                    assignToUserId: project.attributes.assignToUserId || '',
                    shipToContactId: project.attributes.shipToContactId || '',
                    potentialAmount: project.attributes.potentialAmount || '0',
                    probability: project.attributes.probability || '0.10',
                    customFieldValues: project.attributes.customFieldValues || {},
                    documents: project.attributes.documents || [],
                    images: project.attributes.images || [],
                    location: project.attributes.location || null,
                    locationId: project.attributes.locationId || '',
                    poNumber: project.attributes.poNumber || '',
                }
            },
            showCustomerSectionInfoBanner: false,
            showProjectSectionInfoBanner: false,
            quote: this.props.quote || null,
        }
        this.className = this.props.className || ''
        this.handleStartNewProject = this.handleStartNewProject.bind(this)
        this.handleCustomerChanged = this.handleCustomerChanged.bind(this)
        this.displayInfoProjectFirstBanner = this.displayInfoProjectFirstBanner.bind(this)
        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.refreshObject = this.props.refreshObject || defaultCallback
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            quoteId: nextProps.quoteId || '',
            quote: nextProps.quote || null,
            initialContactId: nextProps.initialContactId,
            isEditable: nextProps.isEditable || false,
            project: nextProps.value || { id: '', attributes: {} },
            showCustomerSectionInfoBanner: nextProps.showCustomerSectionInfoBanner,
            showProjectSectionInfoBanner: nextProps.showProjectSectionInfoBanner,
        }, () => {
            this.setState({
                contactId: this.state.project.attributes.contactId,
            })
        })
    }

    handleCustomerChanged(contactId, customerName) {
        let project = this.state.project
        if (!project.attributes.title) {
            project.attributes.title = this.props.intl.formatMessage(messages['title_template'], {
                customerName: customerName
            })
        }
        this.setState({
            contactId: contactId,
            project: project,
            initialContactId: '',
        }, () => {
            this.onChange(this.getCurrentProject())
        })
    }

    handleStartNewProject(event) {
        event.preventDefault()
        let contactId = this.state.initialContactId
        if (this.state.contactId) {
            contactId = this.state.contactId
        }
        AppContext.getApiClient().get('/contacts/' + contactId).then(c => {
            this.handleCustomerChanged(contactId, c.attributes.name)
        })
    }

    getCurrentProject() {
        return {
            projectId: this.state.project.id,
            contactId: this.state.contactId,
            title: this.state.project.attributes.title,
            description: this.state.project.attributes.description,
            assignToUserId: this.state.project.attributes.assignToUserId,
            shipToContactId: this.state.project.attributes.shipToContactId,
            potentialAmount: this.state.project.attributes.potentialAmount,
            probability: this.state.project.attributes.probability,
            customFieldValues: this.state.project.attributes.customFieldValues,
            imageIds: this.state.project.attributes.imageIds,
            documentIds: this.state.project.attributes.documentIds,
            documents: this.state.project.attributes.documents,
            images: this.state.project.attributes.images,
            location: this.state.project.attributes.location,
            locationId: this.state.project.attributes.locationId,
            poNumber: this.state.project.attributes.poNumber,
        }
    }

    displayInfoProjectFirstBanner() {
        if (this.state.showProjectSectionInfoBanner) {
            return <div className="alert alert-info alert-dismissible fade show" role="alert">
                <FormattedMessage
                    id="quote.edit.project.customer.define_project_details_first_banner"
                    defaultMessage="You must first provide some details about the project."
                />
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        }
        return ""
    }


    render() {
        if (!this.state.project) {
            return ''
        }

        let extraClass = ""
        if (!this.state.contactId && !this.state.initialContactId) {
            extraClass = "d-none"
        }
        return (
            <div className={this.state.className + ' row m-0 py-1 px-3 '}>
                {
                    !this.state.project.id ?
                        <div className="col-md-12">
                            <div className="row px-3">
                                <h4 className="p-0 custom-lead" tabIndex="-1" id="quote.edit.project.customer_section_begin">
                                    <FormattedMessage
                                        id="quote.edit.project.contact_box_title"
                                        defaultMessage="Contact"
                                    />
                                </h4>
                            </div>
                            <ProjectCustomerEditForm
                                className="px-3"
                                initialContactId={this.state.initialContactId}
                                value={this.state.contactId}
                                quoteId={this.state.quoteId}
                                isEditable={this.state.isEditable}
                                onChange={this.handleCustomerChanged}
                                showCustomerSectionInfoBanner={this.state.showCustomerSectionInfoBanner}
                                renderContactEnabled={!this.state.project.id}
                            />
                        </div> : ''
                }
                {
                    this.state.project.id ? <div className={"col-md-12 " + extraClass}>
                        <div className="row">
                            <div className="col-12">
                                <ProjectDetailsEditForm
                                    initialContactId={this.state.initialContactId}
                                    quote={this.state.quote}
                                    proposal={this.state.proposal}
                                    project={this.state.project}
                                    onChange={this.onChange}
                                    isEditable={this.state.isEditable}
                                    refreshObject={this.refreshObject}
                                />
                            </div>
                        </div>
                    </div> : <div className={"col-md-12 " + extraClass}>
                            <div className="text-center mt-3" >
                                <button onClick={this.handleStartNewProject} className="btn btn-primary btn-lg">
                                    <FormattedMessage
                                        id="project.form.edit.start_new_quote_btn"
                                        defaultMessage="Start new quote"
                                    />
                                </button>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default injectIntl(ProjectEdit)





// WEBPACK FOOTER //
// ./src/quote/project/edit.component.jsx